import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMic = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8334 8.33337V10C15.8334 11.5471 15.2188 13.0309 14.1249 14.1248C13.0309 15.2188 11.5472 15.8334 10.0001 15.8334M10.0001 15.8334C8.45299 15.8334 6.96925 15.2188 5.87529 14.1248C4.78133 13.0309 4.16675 11.5471 4.16675 10V8.33337M10.0001 15.8334V19.1667M6.66675 19.1667H13.3334M10.0001 0.833374C9.33704 0.833374 8.70116 1.09677 8.23231 1.56561C7.76347 2.03445 7.50008 2.67033 7.50008 3.33337V10C7.50008 10.6631 7.76347 11.299 8.23231 11.7678C8.70116 12.2367 9.33704 12.5 10.0001 12.5C10.6631 12.5 11.299 12.2367 11.7678 11.7678C12.2367 11.299 12.5001 10.6631 12.5001 10V3.33337C12.5001 2.67033 12.2367 2.03445 11.7678 1.56561C11.299 1.09677 10.6631 0.833374 10.0001 0.833374Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMic;
